gsap.registerPlugin(MotionPathPlugin, SplitText);

const splitText = new SplitText('#feel-magic-split', { 
  type: 'chars',
  charsClass: "special"
});

const tl = gsap.timeline({
  paused: true,
  reversed: true,
  onComplete: () => tl.restart()
});

const dur = 20;
const each = dur * 0.00605;

function roundTo2(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

splitText.chars.forEach((char, i) => {
  char.classList.add('c'+char.innerHTML)
  const timeOffset = i * each;
  const startTime = dur / 2 + timeOffset;
  const pathOffset = startTime / dur;
  console.log(startTime, pathOffset);
  const tween = gsap.to(splitText.chars[i], {
    motionPath: {
      path: '.feel-magic-path',
      align: '.feel-magic-path',
      alignOrigin: [0.5, 0.5],
      autoRotate: true,
      start: pathOffset,
      end: 1 + pathOffset
    },
    immediateRender: true,
    duration: 20,
    ease: 'none',
  });
  
  tl.add(tween, 0);
});

tl.play()